import axiosInstance from '@/shared/api/axios';
import type { ApiReceiptPublic, ApiReceiptsMyItem } from '@/shared/types/api/receipts';

export const apiReceiptsMyGet = async (): Promise<ApiReceiptsMyItem[]> => {
  const { data } = await axiosInstance.get<ApiReceiptsMyItem[]>('/receipts/my');
  return data;
};

// PUBLIC, no auth. Uses the shared axios instance, but the response interceptor
// deliberately skips the login redirect for `/receipts/public` URLs so an
// unauthenticated visitor with the link/QR still sees the receipt (or a 404).
export const apiReceiptsPublicGet = async (id: string): Promise<ApiReceiptPublic> => {
  const { data } = await axiosInstance.get<ApiReceiptPublic>(`/receipts/public/${id}`);
  return data;
};
